module.exports = __webpack_public_path__ + "assets/b1a7eb15bc711f2eeb0285f2005e98b2.png";